import React, { FunctionComponent } from "react";

import {
  FontIcon,
  TextBadge,
  TextBadgeColor,
  TextBadgeSize
} from "@bps/fluent-ui";
import { usePatientLabel } from "@ui-components/hooks/usePatientLabel.ts";

interface OnlineBookingBadgeProps {
  isAvailableExistingPatients: boolean | null;
  isAvailableNewPatients: boolean | null;
  onClick?: React.MouseEventHandler<HTMLElement>;
}

export const OnlineBookingBadge: FunctionComponent<OnlineBookingBadgeProps> = ({
  isAvailableExistingPatients,
  isAvailableNewPatients,
  onClick
}) => {
  let badgeLabel: string = "Unavailable";
  let badgeColor: TextBadgeColor = TextBadgeColor.lightGrey;
  const patientLabel = usePatientLabel();

  if (isAvailableExistingPatients && isAvailableNewPatients) {
    badgeLabel = `All ${patientLabel}s`;
    badgeColor = TextBadgeColor.green;
  } else if (isAvailableExistingPatients) {
    badgeLabel = "Existing only";
    badgeColor = TextBadgeColor.yellow;
  } else if (isAvailableNewPatients) {
    badgeLabel = "New only";
    badgeColor = TextBadgeColor.yellow;
  }

  return (
    <TextBadge
      horizontal
      badgeColor={badgeColor}
      badgeSize={TextBadgeSize.medium}
      onClick={onClick}
    >
      <FontIcon iconName="Globe" styles={{ root: { marginRight: 4 } }} />
      {badgeLabel}
    </TextBadge>
  );
};
